// import { canUseDOM } from 'exenv';

export function companyIndexSectionPageLoading(resp = {}, store = {}) {
  return {
    type: 'COMPANY_INDEX_SECTION_PAGE_LOADING',
    companyIndexSectionPage: resp,
    store
  };
}

export function companyIndexSectionPageLoaded(resp = {}, store = {}) {
  return {
    type: 'COMPANY_INDEX_SECTION_PAGE_LOADED',
    companyIndexSectionPage: resp,
    store
  };
}

export function companyIndexSectionPageLoadError(error, store = {}) {
  return {
    type: 'COMPANY_INDEX_SECTION_PAGE_ERROR',
    companyIndexSectionPage: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store
  };
}
